import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridPrivateLesson';
const DEFAULT_VALUE = false;

export const usePrivateLesson = () => {
	const [privateLesson, setPrivateLesson] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { privateLesson, setPrivateLesson };
};
